import {Button} from '@wandb/weave/components/Button';
import React, {useEffect, useState} from 'react';

export const AccordionSectionHeader = ({
  title,
  isOpen,
  setIsOpen,
}: {
  title: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  return (
    <div className="mx-24 my-20 flex items-center justify-between">
      <div className="text-lg font-semibold">{title}</div>
      <Button
        variant="ghost"
        icon={isOpen ? 'chevron-up' : 'chevron-down'}
        aria-label={isOpen ? 'collapse' : 'expand'}
        onClick={() => setIsOpen(!isOpen)}></Button>
    </div>
  );
};
export const AccordionSection = ({
  title,
  children,
  initialOpen,
}: {
  title: string;
  children: React.ReactNode;
  initialOpen: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  useEffect(() => {
    setIsOpen(initialOpen);
  }, [initialOpen]);

  return (
    <section className="border-t-[1px] border-wb-border">
      <AccordionSectionHeader
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title={title}
      />
      {isOpen && <div className="mx-24 my-20">{children}</div>}
    </section>
  );
};
